

import React from 'react';
// import DoneIcon from '@mui/icons-material/Done';
import { Done } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        marginTop: 15,
        display:'flex',
        justifyContent:'center',
        flexWrap:'wrap',
    },
    circleDona:{
        borderRadius:'50%',
        width:40,
        height:40,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        margin:2,
    },
    circleDefualte:{
        borderRadius:'50%',
        width:40,
        height:40,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        margin:2,
    },
    btnDisable:{
        backgroundColor:'#ECECEC',
        color:" rgb(100,116,139)",
    }
}))

const StepHeader = ({ data, indexQuestion }) => {

    const classes = useStyles();

    const handelClassName = (index) => {

        if (index === indexQuestion) {
            return `bg-primaryColor text-white`
        }
        return classes['btnDisable']
    }

    return (
        <>
            <div  className={classes['root']}>
                {data.map((itm, ind) => (
                    <>
                        {
                            ind < indexQuestion
                                ? (
                                    <div className={`${classes['circleDona']} bg-primaryColor text-white `}>
                                        <Done />
                                    </div>
                                )
                                : (

                                    <div className={` ${classes['circleDefualte']} ${handelClassName(ind)} `}>
                                        {ind + 1}
                                    </div>
                                )
                        }
                    </>
                ))}
            </div>
        </>
    );
}

export default StepHeader;



